import { Injectable, Signal, WritableSignal, signal, computed } from '@angular/core';
import { DateTime, Info, Interval } from 'luxon';
import { AmplifyModelService } from './amplify-model-service.service';
import { UsersApiService } from './users-api.service';
import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../../../amplify/data/resource';

const client = generateClient<Schema>();

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  data: any = {};
  config: any = {
    earliestStartTime: '06:00:00',
    latestEndTime: '21:00:00'
  }
  periodViews: any = [
    //{ label: 'Daily', id: 'day', period: 'day', smallPeriod: 'hour', largePeriod: 'day', splitBy: { hour: 1 }, smallWidth: 125 },
    { label: 'Work Day', id: 'workDay', period: 'day', smallPeriod: 'hour', largePeriod: 'day', splitBy: { hour: 1 }, smallWidth: 125 },
    { label: 'Weekly', id: 'week', period: 'week', smallPeriod: 'day', largePeriod: 'week', splitBy: { day: 1 }, smallWidth: 100 },
    //{label: 'Bi-Weekly', id: '2week', period: 'week', periods: 2, smallPeriod: 'day', largePeriod: 'week', largePeriods: 2, splitBy: {day:1}},
    { label: 'Monthly', id: 'month', period: 'month', smallPeriod: 'day', largePeriod: 'month', splitBy: { day: 1 }, smallWidth: 40 },
    //{label: '6 Months', id: '6month', period: 'month', periods: 6, smallPeriod: 'week', largePeriod: 'month', largePeriods: 6},
    //{ label: 'Yearly', id: 'year', period: 'year', smallPeriod: 'day', largePeriod: 'year', splitBy: { day: 1 }, largeSplitBy: { month: 1 }, smallWidth: 40, midWidth: 1200 },
  ];

  //scrollPosition: WritableSignal<number> = signal(0);
  scrollPosition = signal(0);
  scrollSyncWidth: WritableSignal<number> = signal(0);

  selectedPeriod: WritableSignal<any> = signal(this.periodViews[0]);
  today: Signal<DateTime> = signal(DateTime.local());
  selectedDate: Signal<DateTime> = signal(DateTime.local());
  //firstSegmentOfActivePeriod: WritableSignal<DateTime> = signal(
  firstSegmentOfActivePeriod: Signal<DateTime> = computed(() => {
    //let defaultPeriods = ['day', 'week', 'month', 'year'];
    //if (defaultPeriods.includes(this.selectedPeriod().id)){
      return this.selectedDate().startOf(this.selectedPeriod().period);
    //}
    //else {
    //}
  });

  timeframeStart = computed(() => {
    if (this.selectedPeriod().id == 'workDay') {
      let timePartsArr = this.config.earliestStartTime.split(':');
      let hr = parseInt(timePartsArr[0]);
      let min = parseInt(timePartsArr[1]);
      let sec = parseInt(timePartsArr[2]);
      let ms = 0;
      return this.selectedDate().set({ hour: hr, minute: min, second: sec, millisecond: ms });
    }
    else if (this.selectedPeriod().id == 'year') {
      return this.selectedDate().startOf('month');
    }
    else {
      return this.firstSegmentOfActivePeriod().startOf(this.selectedPeriod().largePeriod);
    }
    //return this.firstSegmentOfActivePeriod().startOf(this.selectedPeriod().largePeriod);
  });

  timeFrameEnd = computed(() => {
    if (this.selectedPeriod().id == 'workDay') {
      let timePartsArr = this.config.latestEndTime.split(':');
      let hr = parseInt(timePartsArr[0]);
      let min = parseInt(timePartsArr[1]);
      let sec = parseInt(timePartsArr[2]);
      let ms = 0;
      return this.selectedDate().set({ hour: hr, minute: min, second: sec, millisecond: ms });
    }
    else if (this.selectedPeriod().id == 'year'){
      return this.firstSegmentOfActivePeriod().endOf(this.selectedPeriod().largePeriod);
    }
    else {
      return this.firstSegmentOfActivePeriod().endOf(this.selectedPeriod().largePeriod).endOf(this.selectedPeriod().smallPeriod)
    }
  });

  timeFrameDiff = computed(() => {
    return this.timeFrameEnd().diff(this.timeframeStart())
  });

  timeFrameMS = computed(() => {
    return this.timeFrameDiff().milliseconds;
  });

  weekDayNames: Signal<string[]> = signal(Info.weekdays('short'));

  midRangesInPeriod: Signal<DateTime[]> = computed(() => {
    if (!this.selectedPeriod().largeSplitBy) return [];

    let start = this.timeframeStart();//this.firstSegmentOfActivePeriod().startOf(this.selectedPeriod().largePeriod);
    let end = this.firstSegmentOfActivePeriod().endOf(this.selectedPeriod().largePeriod);

    return Interval.fromDateTimes(start, end)
      .splitBy(this.selectedPeriod().largeSplitBy)
      .map((d) => {
        if (d.start === null) {
          throw new Error('Wrong date');
        }
        return d.start;
      })
  });

  rangesInPeriod: Signal<DateTime[]> = computed(() => {

    let start = this.timeframeStart(); //this.firstSegmentOfActivePeriod().startOf(this.selectedPeriod().largePeriod);
    let end = this.timeFrameEnd(); //this.firstSegmentOfActivePeriod().endOf(this.selectedPeriod().largePeriod).endOf(this.selectedPeriod().smallPeriod);



    return Interval.fromDateTimes(start, end)
      .splitBy(this.selectedPeriod().splitBy)
      .map((d) => {
        if (d.start === null) {
          throw new Error('Wrong date');
        }
        return d.start;
      })
  });

  smallPeriodWidth = computed(() => {
    return this.selectedPeriod().smallWidth
  });

  smallPeriodHolderWidth = computed(() => {
    switch (this.selectedPeriod().period) {
      case 'week':
      case 'month':
        var width = this.smallPeriodWidth() * this.rangesInPeriod().length;
        if (width < this.scrollSyncWidth()) {
          width = this.scrollSyncWidth();
        }
        return width;
      default:
        return this.smallPeriodWidth() * this.rangesInPeriod().length;
    }

  });

  smallPeriodDisplayWidth = computed(() => {
    return this.smallPeriodHolderWidth() / this.rangesInPeriod().length;
  })


  constructor(private ams: AmplifyModelService, private usersApi: UsersApiService) { }

  setScrollPosition(position: number) {
    this.scrollPosition.set(position);
  }

  setScrollSyncWidth(width: number) {
    this.scrollSyncWidth.set(width);
  }

  setSelectedView(viewName: string) {
    let view = this.periodViews.find(x => x.id == viewName);
    if (view) {
      this.selectedPeriod.set(view);
      this.setEntryStyles();
    }
  }

  setSelectedDate(date: DateTime) {
    this.data.selectedDate.set(date);
  }

  setBaseData() {
    this.data.today = this.today;
    this.data.firstSegmentOfActivePeriod = this.firstSegmentOfActivePeriod;
    this.data.weekDayNames = this.weekDayNames;
    this.data.selectedPeriod = this.selectedPeriod;
    this.data.selectedDate = this.selectedDate;
    this.data.midRangesInPeriod = this.midRangesInPeriod;
    this.data.rangesInPeriod = this.rangesInPeriod;
    this.data.view = this.selectedPeriod();

    this.setUsers();

    this.data.timeframeStart = this.timeframeStart; //().startOf(this.selectedPeriod().largePeriod);//.toFormat('yyyy LLL dd h:mm:ss a');
    this.data.timeFrameEnd = this.timeFrameEnd; //this.firstSegmentOfActivePeriod().endOf(this.selectedPeriod().largePeriod).endOf(this.selectedPeriod().smallPeriod);//.toFormat('yyyy LLL dd  h:mm:ss a')
    this.data.timeFrameDiff = this.timeFrameDiff; //this.data.timeFrameEnd.diff(this.data.timeframeStart);
    this.data.timeFrameMS = this.timeFrameMS; //this.data.timeFrameDiff.milliseconds;
    this.data.scrollSyncWidth = this.scrollSyncWidth;

    //console.log('setBaseData range start', this.data.timeframeStart);
    //console.log('setBaseData range end', this.data.timeFrameEnd);
    //console.log('rangesInPeriod', this.data.rangesInPeriod());
    //console.log('midRangesInPeriod', this.data.midRangesInPeriod());
    console.log('SchedulerService data', this.data);
  }

  setUsers() {
    this.data.users = this.usersApi.getUsers();
    this.data.sales = this.usersApi.getUsersInGroup('Sales');
  }

  getData() {
    if (!this.data.today) {
      this.setBaseData();
    }
    console.log('SchedulerService data', this.data);
    this.getSchedules();
    return this.data;
  }

  getSchedules() {
    this.ams.listItemsForModel('Schedule').subscribe({
      next: ({ items, isSynced }) => {
        console.log('got schedules', this.data);
        this.data.schedules = items;
        this.getScheduleEntries();
      },
    });
  }

  getScheduleEntries() {
    // Get the current time range for filtering
    // Converted to UTC before serializing: DynamoDB compares AWSDateTime
    // filter bounds (gt/lt below) as plain strings, not real dates, and
    // appointments are stored as UTC "...Z" timestamps (Date.toISOString()
    // in AppointmentBuilderComponent). Luxon's .toISO() keeps the local
    // zone offset (e.g. "-06:00") by default, which sorts lexicographically
    // out of order against "Z" timestamps with the same wall-clock time,
    // causing in-range appointments to be silently excluded.
    const rangeStart = this.timeframeStart().toUTC().toISO();
    const rangeEnd = this.timeFrameEnd().toUTC().toISO();
    
    // Handle potential null values from toISO()
    if (!rangeStart || !rangeEnd) {
      console.error('Invalid date range for appointments query');
      return;
    }
    
    console.log('Querying appointments from', rangeStart, 'to', rangeEnd);
    
    // Query with date range filter at the backend level
    this.getScheduleEntriesInRange(rangeStart, rangeEnd).subscribe({
      next: ({ items, isSynced }) => {
        console.log('got filtered appointments from backend:', items.length);
        this.data.appointments = items;
        this.setEntryStyles();
      },
    });
  }

  private getScheduleEntriesInRange(rangeStart: string, rangeEnd: string): any {
    // Create filter for appointments that overlap with the scheduler range
    // Appointment overlaps if: end_date_time > range_start AND start_date_time < range_end
    const filter = {
      and: [
        { end_date_time: { gt: rangeStart } },
        { start_date_time: { lt: rangeEnd } }
      ]
    };
    
    return client.models.ScheduleEntry.observeQuery({ filter });
  }



  setEntryStyles(entryArr?: any[]) {
    console.log('timeFrameMS: ' + this.timeFrameMS());
    for (let e of this.data.appointments) {
      e.style = {
        //width: this.getSpanPercentage(e),
        //left: this.getSpanStartOffsetPercentage(e)
        width: this.getSpanWidthPixels(e),
        left: this.getSpanStartOffsetPixels(e)
      }
      console.log('finished setEntryStyles for e', e);
    }
  }

  /**** Methods for working with schedule entries ****/
  getSpanWidthPixels(entry: any): string {
    let entryEnd = DateTime.fromISO(entry.end_date_time);
    let entryStart = DateTime.fromISO(entry.start_date_time);
    console.log('getSpanWidthPixels entryStart: ', entryStart.toString(), 'entry', entry);
    let diff = entryEnd.diff(entryStart);
    let entryMs = diff.milliseconds;
    let entryWidthPercentage = entryMs / this.timeFrameMS();
    let entryWidthPixels = Math.round(entryWidthPercentage * this.smallPeriodHolderWidth());
    console.log('getSpanWidthPixels entryWidthPixels', entryWidthPixels);
    return entryWidthPixels + 'px';
  }

  getSpanStartOffsetPixels(entry: any): string {
    console.log('getSpanStartOffsetPixels timeframeStart: ', this.timeframeStart().toString(), 'entry', entry);
    let entryStart = DateTime.fromISO(entry.start_date_time);
    let diff = entryStart.diff(this.timeframeStart());
    let entryOffsetMs = diff.milliseconds;
    let offsetPercent = entryOffsetMs / this.timeFrameMS()
    let offsetPixels = Math.round(offsetPercent * this.smallPeriodHolderWidth());
    return offsetPixels + 'px';
  }

  getSpanPercentage(entry: any): string {
    let entryEnd = DateTime.fromISO(entry.end_date_time);
    let entryStart = DateTime.fromISO(entry.start_date_time);
    console.log('getSpanPercentage entryStart: ', entryStart.toString(), 'entry', entry);
    let diff = entryEnd.diff(entryStart);
    let entryMs = diff.milliseconds;
    return Math.round(entryMs / this.timeFrameMS() * 100) + '%';
  }

  getSpanStartOffsetPercentage(entry: any): string {
    let entryStart = DateTime.fromISO(entry.start_date_time);
    let diff = entryStart.diff(this.timeframeStart());
    let entryOffsetMs = diff.milliseconds;
    return Math.round(entryOffsetMs / this.timeFrameMS() * 100) + '%';
  }

  /**
   * Groups appointments by small period for compact display in week/month/year views
   */
  getAppointmentsBySmallPeriod(scheduleId: string): any[] {
    if (!this.data.appointments) return [];
    
    const scheduleAppointments = this.data.appointments.filter(
      (appt: any) => appt.scheduleId === scheduleId
    );

    // For day/workDay views, return appointments as-is (no grouping needed)
    if (this.selectedPeriod().id === 'day' || this.selectedPeriod().id === 'workDay') {
      return scheduleAppointments;
    }

    // Debug logging for yearly view
    if (this.selectedPeriod().id === 'year') {
      console.log('Yearly view - ranges count:', this.rangesInPeriod().length);
      console.log('Yearly view - schedule appointments:', scheduleAppointments.length);
    }

    // Group appointments by small period
    const groupedAppointments: { [key: string]: any[] } = {};
    const ranges = this.rangesInPeriod();

    // Initialize groups for each small period
    ranges.forEach((range, index) => {
      const key = this.getSmallPeriodKey(range);
      groupedAppointments[key] = [];
    });

    // Group appointments into their respective small periods
    scheduleAppointments.forEach((appt: any) => {
      const apptStart = DateTime.fromISO(appt.start_date_time);
      const smallPeriodKey = this.getSmallPeriodKey(apptStart);
      
      if (groupedAppointments[smallPeriodKey]) {
        groupedAppointments[smallPeriodKey].push(appt);
      }
    });

    // Convert grouped appointments to display format
    const result: any[] = [];
    ranges.forEach((range, index) => {
      const key = this.getSmallPeriodKey(range);
      const appointments = groupedAppointments[key];
      
      if (appointments && appointments.length > 0) {
        // Create a grouped appointment entry
        const groupedEntry = {
          id: `grouped-${scheduleId}-${key}`,
          isGrouped: true,
          smallPeriodStart: range,
          appointments: appointments,
          count: appointments.length,
          name: this.getGroupedDisplayName(appointments),
          style: this.getGroupedEntryStyle(range, index)
        };
        result.push(groupedEntry);
      }
    });

    // Debug logging for yearly view
    if (this.selectedPeriod().id === 'year') {
      console.log('Yearly view - grouped entries created:', result.length);
      console.log('Yearly view - grouped entries:', result.map(r => ({ count: r.count, key: r.id })));
    }

    return result;
  }

  private getSmallPeriodKey(dateTime: DateTime): string {
    const splitBy = this.selectedPeriod().splitBy;
    
    // Get the time unit from splitBy (e.g., 'day' from { day: 1 })
    const timeUnit = Object.keys(splitBy)[0];
    
    switch (timeUnit) {
      case 'day':
        return dateTime.startOf('day').toISODate() || '';
      case 'week':
        return dateTime.startOf('week').toISODate() || '';
      case 'hour':
        return dateTime.startOf('hour').toISO() || '';
      case 'month':
        return dateTime.startOf('month').toISODate() || '';
      default:
        return dateTime.startOf('day').toISODate() || '';
    }
  }

  private getGroupedDisplayName(appointments: any[]): string {
    if (appointments.length === 1) {
      return appointments[0].name;
    }
    return `${appointments.length} appointments`;
  }

  private getGroupedEntryStyle(range: DateTime, index: number): any {
    //const smallWidth = this.selectedPeriod().smallWidth;
    const smallDisplayWidth = this.smallPeriodDisplayWidth();
    const adjustedWidth = smallDisplayWidth; // account for pixel border
    const position = this.calculateTimePosition(range);
    return {
      width: `${adjustedWidth}px`,
      left: `${position * smallDisplayWidth}px`
    };
  }

  private calculateTimePosition(range: DateTime): number {
    const splitBy = this.selectedPeriod().splitBy;
    const timeUnit = Object.keys(splitBy)[0];
    const timeframeStart = this.timeframeStart();
    
    switch (timeUnit) {
      case 'day':
        // For weekly view: position based on day of week (0-6)
        // For monthly view: position based on day of month relative to start
        if (this.selectedPeriod().id === 'week') {
          return range.weekday - 1; // Luxon weekday is 1-7, we want 0-6
        } else {
          return range.diff(timeframeStart, 'days').days;
        }
      
      case 'hour':
        // For daily view: position based on hour relative to start
        return range.diff(timeframeStart, 'hours').hours;
      
      case 'week':
        // For yearly view: position based on week relative to start
        return range.diff(timeframeStart, 'days').days;
      
      case 'month':
        // Position based on month relative to start
        return range.diff(timeframeStart, 'months').months;
      
      default:
        return range.diff(timeframeStart, 'days').days;
    }
  }
}
